import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/authService";
import useWakeUpPing from "../hooks/useWakeUpPing";
import LoginForm from "../components/Auth/LoginForm";
import "./Login.scss";

import {
  normalizeStatus,
  normalizeRole,
  canManageClients,
  canManageFirmware,
  canDownloadFirmware,
  canDownloadClientDocs,
} from "../services/authz";

export default function Login() {
  useWakeUpPing();

  const { currentUser, userRole, userStatus } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) return;

    const status = normalizeStatus(userStatus);
    const role = normalizeRole(userRole);

    const isApprovedUser = status === "active" || status === "approved";
    if (!isApprovedUser) return;

    if (canManageClients(status, role)) {
      navigate("/admin", { replace: true });
      return;
    }

    if (canManageFirmware(status, role)) {
      navigate("/firmware", { replace: true });
      return;
    }

    if (canDownloadFirmware(status, role)) {
      navigate("/firmware", { replace: true });
      return;
    }

    if (canDownloadClientDocs(status, role)) {
      navigate("/dashboard", { replace: true });
      return;
    }

    navigate("/dashboard", { replace: true });
  }, [currentUser, userRole, userStatus, navigate]);

  return (
    <div className="auth-page auth-page--login">
      <div className="auth-page__inner auth-page__inner--login">
        <LoginForm />
      </div>
    </div>
  );
}
